var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20610_176362)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0703125,
    width: 23.0769,
    height: 14,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6066 9.33073C13.1231 9.33073 14.3539 8.2854 14.3539 6.9974C14.3539 5.7094 13.1231 4.66406 11.6066 4.66406C10.0901 4.66406 8.85938 5.7094 8.85938 6.9974C8.85938 8.2854 10.0901 9.33073 11.6066 9.33073ZM11.6066 8.3974C12.5165 8.3974 13.255 7.7702 13.255 6.9974C13.255 6.2246 12.5165 5.5974 11.6066 5.5974C10.6967 5.5974 9.95828 6.2246 9.95828 6.9974C9.95828 7.7702 10.6967 8.3974 11.6066 8.3974Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.612 7.46458C11.9154 7.46458 12.1614 7.25565 12.1614 6.99792C12.1614 6.74018 11.9154 6.53125 11.612 6.53125C11.3085 6.53125 11.0625 6.74018 11.0625 6.99792C11.0625 7.25565 11.3085 7.46458 11.612 7.46458Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.0078125 10H23.9922V14H-0.0078125V10Z",
    fill: "#249F58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.0078125 0H23.9922V4H-0.0078125V0Z",
    fill: "#FF6C2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20610_176362"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0703125,
    width: 23.0769,
    height: 14,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.f9237c4b9fd9a52b933754ae5b38180d.svg";
export { ForwardRef as ReactComponent };